/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
  Skeleton,
  InputAdornment,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useEffect, useMemo, useState } from "react";
import CustomRightImage from "@components/CustomRightImagev2";
import { RootState, useAppDispatch } from "@store/store";
import { useSelector } from "react-redux";
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import { formatCurrency } from "@helpers/funciones";
import VehiculosTable from "@components/arredamiento/TableVehicles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ButtonTypeSelectedCustom } from "@components/ButtonTypeSelectedCustom";
import { StyledSlider } from "@components/CustomSlider";
import {
  useDeleteVehicleByIdMutation,
  useLazyGetLeasingListQuery,
  usePatchLeasingMutation,
  usePostLeasingMutation,
} from "@api/leasing";
import { LeasingPost, LeasingStructure } from "@interfaces/LeasingTypes";
import { CustomDialog } from "@components/CustomDialog";
import { useLazyGetPriceVehiclesByVersionQuery, useLazyGetTaxSystemsQuery } from "@api/catalogs";
import {
  useLazyGetVehiclesYearsQuery,
  useLazyGetVehiclesByYearQuery,
  useLazyGetVehiclesByYearAndMakeQuery,
  useLazyGetVehiclesByYearMakeAndModelQuery,
} from "@api/catalogs";
import icon_check from "@assets/img/check_black.svg";
import { useFormik } from "formik";
import * as yup from "yup";
import { ApiError, CarVersionPrice, LoanCondiciones, TaxSystem } from "@interfaces/index";
import {
  useLazyGetConditionsByIdQuery,
  usePostValidateNextStageMutation,
  usePutConditionMutation,
} from "@api/applications";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { STATUS_CATALOG, TAX_SYSTEM_TYPE } from "@helpers/constantes";
import { setLoanStatus } from "@store/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { setModalErrorVisible } from "@store/slices/appSlice";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

interface MarketStructure {
  value: number;
  label: string;
}
const OfertaArrendamiento = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const interfaceConfig = useInterfaceConfig();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const companyData = useSelector((state: RootState) => state.register.company);
  const application = useSelector((state: RootState) => state.register.application);
  const accountUser = useSelector((state: RootState) => state.register.account_user);

  const [selectedTerm, setSelectedTerm] = useState<number | null>(null);
  const [selectedAdvance, setSelectedAdvance] = useState<number>(20);
  const [vehicles, setVehicles] = useState<Array<LeasingStructure>>([]);

  const [getLeasingList] = useLazyGetLeasingListQuery();
  const [triggerGetPriceVehiclesByVersion] = useLazyGetPriceVehiclesByVersionQuery();
  const [triggerListVehicleYears] = useLazyGetVehiclesYearsQuery();
  const [triggerGetVehicleByYear] = useLazyGetVehiclesByYearQuery();
  const [triggerGetVehicleByYearAndBrand] = useLazyGetVehiclesByYearAndMakeQuery();
  const [triggerGetVehicleByYearBrandAndModel] = useLazyGetVehiclesByYearMakeAndModelQuery();
  const [deleteVehicleById] = useDeleteVehicleByIdMutation();
  const [getConditions] = useLazyGetConditionsByIdQuery();
  const [getTaxSystems] = useLazyGetTaxSystemsQuery();
  const [patchLeasing] = usePatchLeasingMutation();
  const [postLeasing] = usePostLeasingMutation();
  const [triggerPostNextStage] = usePostValidateNextStageMutation();
  const [putCondition] = usePutConditionMutation();

  const [openEditVehicle, setOpenEditVehicle] = useState<boolean>(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [vehicleType, setVehicleType] = useState<string>("cars");
  const [listYears, setListYears] = useState<string[]>([]);
  const [brandsOptions, setBrandsOptions] = useState<Array<{ code: string; name: string }>>([]);
  const [modelsOptions, setModelsOptions] = useState<Array<{ code: string; name: string }>>([]);
  const [versionsOptions, setVersionsOptions] = useState<Array<{ code: string; name: string }>>([]);
  const [isLoadingForm, setIsLoadingForm] = useState<boolean>(false);
  const [editVehiclePrice, setEditVehiclePrice] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [condition, setCondition] = useState<LoanCondiciones | null>(null);
  const [taxSystems, setTaxSystems] = useState<TaxSystem | null>(null);
  const [vehicleValueDetail, setVehicleValueDetail] = useState<CarVersionPrice | null>(null);
  const [displayPrice, setDisplayPrice] = useState<string>("");

  const [termMarket, setTermMarket] = useState<number[]>([]);
  const [residualPercentageMarket, setResidualPercentageMarket] = useState<MarketStructure[]>([]);
  const [advancePercentageMarket, setAdvancePercentageMarket] = useState<MarketStructure[]>([]);
  const [submitError, setSubmitError] = useState<boolean>(false);

  const [configConditions, setConfigConditions] = useState({
    min_term: 12,
    max_term: 60,
    min_advance_percentage: 10,
    max_advance_percentage: 35,
    min_residual_percentage: 10,
    max_residual_percentage: 35,
    interest_rate: 0,
    amount: 0,
    term: 0,
    jump_term: 12,
    jump_advance_percentage: 5,
    jump_residual_percentage: 5,
  });

  const amount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const [responseLeasing, responseYears, responseConditions, responseTaxSystems] = await Promise.all([
          getLeasingList(String(application.id)).unwrap(),
          triggerListVehicleYears().unwrap(),
          getConditions(application.id).unwrap(),
          getTaxSystems("LS001").unwrap(),
        ]);

        const activeVheicles = responseLeasing.filter((v) => v.active);
        const activeCondition = responseConditions.find((item) => item.active);

        if (activeCondition) {
          setCondition(activeCondition);
        }
        setVehicles(activeVheicles || []);
        setListYears(responseYears);
        setTaxSystems(responseTaxSystems);
      } catch (error) {
        console.log("Ha ocurrido un error", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setConfigConditions({
      min_term:
        condition?.approved_min_term !== null &&
        condition?.approved_min_term !== undefined &&
        condition?.approved_min_term > 0
          ? Number(condition?.approved_min_term)
          : taxSystems?.min_term ?? 12,
      max_term:
        condition?.approved_max_term !== null &&
        condition?.approved_max_term !== undefined &&
        condition?.approved_max_term > 0
          ? Number(condition?.approved_max_term)
          : taxSystems?.max_term ?? 60,
      min_advance_percentage:
        condition?.approved_min_advance_percentage !== null &&
        condition?.approved_min_advance_percentage !== undefined &&
        condition?.approved_min_advance_percentage > 0
          ? Number(condition?.approved_min_advance_percentage)
          : taxSystems?.min_advance_percentage ?? 10,
      max_advance_percentage:
        condition?.approved_max_advance_percentage !== null &&
        condition?.approved_max_advance_percentage !== undefined &&
        condition?.approved_max_advance_percentage > 0
          ? Number(condition?.approved_max_advance_percentage)
          : taxSystems?.max_advance_percentage ?? 35,

      min_residual_percentage:
        condition?.approved_min_residual_percentage !== null &&
        condition?.approved_min_residual_percentage !== undefined &&
        condition?.approved_min_residual_percentage > 0
          ? Number(condition?.approved_min_residual_percentage)
          : taxSystems?.min_residual_percentage ?? 10,
      max_residual_percentage:
        condition?.approved_max_residual_percentage !== null &&
        condition?.approved_max_residual_percentage !== undefined &&
        condition?.approved_max_residual_percentage > 0
          ? Number(condition?.approved_max_residual_percentage)
          : taxSystems?.max_residual_percentage ?? 35,
      interest_rate:
        condition?.interest_rate !== null && condition?.interest_rate !== undefined && condition?.interest_rate > 0
          ? Number(condition?.interest_rate)
          : interfaceConfig?.interest_rate ?? 0,
      amount:
        condition?.approved_amount !== null &&
        condition?.approved_amount !== undefined &&
        condition?.approved_amount > 0
          ? Number(condition?.approved_amount)
          : condition?.selected_amount ?? 0,
      term:
        condition?.approved_term !== null && condition?.approved_term !== undefined && condition?.approved_term > 0
          ? Number(condition?.approved_term)
          : condition?.selected_term ?? 0,
      jump_term: taxSystems?.jump_term ?? 12,

      jump_advance_percentage: taxSystems?.jump_advance_percentage ?? 5,
      jump_residual_percentage: taxSystems?.jump_residual_percentage ?? 5,
    });
  }, [condition, taxSystems]);

  useEffect(() => {
    const typedCfg = configConditions;

    const min = Number(typedCfg?.min_term ?? 12);
    const max = Number(typedCfg?.max_term ?? 60);
    const jump = Number(typedCfg?.jump_term ?? 12);

    const minResidual = Number(typedCfg?.min_residual_percentage ?? 5);
    const maxResidual = Number(typedCfg?.max_residual_percentage ?? 40);
    const jumpResidual = Number(typedCfg?.jump_residual_percentage ?? 5);

    const minAdvance = Number(typedCfg?.min_advance_percentage ?? 5);
    const maxAdvance = Number(typedCfg?.max_advance_percentage ?? 40);
    const jumpAdvance = Number(typedCfg?.jump_advance_percentage ?? 5);

    const list: number[] = [];
    const listResidual: MarketStructure[] = [];
    const listAdvance: MarketStructure[] = [];

    if (jump > 0 && min > 0 && max >= min) {
      for (let t = min; t <= max; t += jump) {
        list.push(t);
      }
      if (list.length && list[list.length - 1] !== max) {
        list.push(max);
      }
    }

    if (jumpResidual > 0 && minResidual > 0 && maxResidual >= minResidual) {
      for (let r = minResidual; r <= maxResidual; r += jumpResidual) {
        listResidual.push({ value: r, label: `${r}%` });
      }
      if (listResidual.length && listResidual[listResidual.length - 1].value !== maxResidual) {
        listResidual.push({ value: maxResidual, label: `${maxResidual}%` });
      }
    }

    if (jumpAdvance > 0 && minAdvance > 0 && maxAdvance >= minAdvance) {
      for (let r = minAdvance; r <= maxAdvance; r += jumpAdvance) {
        listAdvance.push({ value: r, label: `${r}%` });
      }
      if (listAdvance.length && listAdvance[listAdvance.length - 1].value !== maxAdvance) {
        listAdvance.push({ value: maxAdvance, label: `${maxAdvance}%` });
      }
    }

    setTermMarket(list);
    setResidualPercentageMarket(listResidual);
    setAdvancePercentageMarket(listAdvance);
  }, [configConditions, taxSystems, condition]);

  // Se elimina la precarga de precios por catálogo; se usa estimated_value del servicio

  // Totales agregados basados en datos del servicio y sliders seleccionados
  const leasingTotals = useMemo(() => {
    const rows = vehicles ?? [];
    let totalValue = 0;
    let residualAmount = 0;

    rows.forEach((v) => {
      const advVal = v.approved_advance_value ?? v.selected_advance_value ?? v.requested_advance_value ?? 0;
      const advPerc =
        v.approved_advance_percentage ?? v.selected_advance_percentage ?? v.requested_advance_percentage ?? 0;

      const qty = v.quantity || 1;
      const unitFromEstimated = v.estimated_value;
      // Usar el estimated_value del servicio; si no está, estimar desde anticipo
      const rowTotal =
        unitFromEstimated !== undefined && unitFromEstimated !== null
          ? (unitFromEstimated || 0) * qty
          : advPerc > 0
          ? advVal / (advPerc / 100)
          : 0;
      totalValue += rowTotal;

      const resPerc =
        v.requested_residual_percentage ?? v.selected_residual_percentage ?? v.approved_residual_percentage ?? 0;
      residualAmount += rowTotal * (resPerc / 100);
    });

    const advanceAmount = totalValue * (selectedAdvance / 100);
    const amountToFinance = totalValue - advanceAmount;

    const annualRate = configConditions.interest_rate ?? 0;
    const normalizedAnnualRate = annualRate > 1 ? annualRate / 100 : annualRate;
    const monthlyRate = normalizedAnnualRate / 12;

    const i = monthlyRate;
    const n = selectedTerm || 0;
    const P = amountToFinance;
    const F = residualAmount;

    const monthlyRent =
      i > 0 && n > 0 ? ((P - F / Math.pow(1 + i, n)) * i) / (1 - Math.pow(1 + i, -n)) : n > 0 ? (P - F) / n : 0;

    return { totalValue, advanceAmount, residualAmount, amountToFinance, monthlyRent };
  }, [vehicles, selectedAdvance, selectedTerm, configConditions.interest_rate]);

  // Formik para edición (tal cual el de multi-vehículos)
  const formikEdit = useFormik({
    initialValues: {
      type_vehicle: "",
      year: "",
      brand: "",
      brand_value: "",
      model: "",
      model_value: "",
      version: "",
      version_value: "",
      residual: 20,
      carAmount: 1,
      price: null,
    },
    validationSchema: yup.object().shape({
      year: yup.string().required("Campo requerido"),
      brand: yup.string().required("Campo requerido"),
      model: yup.string().required("Campo requerido"),
      version: yup.string().required("Campo requerido"),
      residual: yup.number().required("Campo requerido"),
      carAmount: yup.number().required("Campo requerido"),
      price: yup.number().nullable(),
    }),
    onSubmit: async (values) => {
      const qty = Number(values.carAmount || 1);

      try {
        setIsLoadingForm(true);

        // Si existe vehicleId => PATCH (editar), si no => POST (crear)
        const currentVehicle = editIndex !== null ? vehicles[editIndex] : null;
        const vehicleId = currentVehicle?.id ?? null;

        const valuesDetails: LeasingPost = {
          loan_application_id: String(application?.id) || "",
          details: {
            vehicle_type: vehicleType === "cars" ? "Autos SUVS " : "Vans o Camiones",
            year: Number(values.year),
            make: (values.brand_value || values.brand) as string,
            model: (values.model_value || values.model) as string,
            version: (values.version_value || values.version) as string,
            car_version_code:
              vehicleValueDetail?.car_version_id ||
              (currentVehicle?.details as { car_version_code?: number } | undefined)?.car_version_code,
            estimated_mileage:
              vehicleValueDetail?.mileage ||
              (currentVehicle?.details as { estimated_mileage?: number } | undefined)?.estimated_mileage,
          },
          quantity: qty,
          requested_advance_percentage: selectedAdvance,
          requested_residual_percentage: values.residual,
          estimated_value:
            vehicleValueDetail?.sale_price ?? currentVehicle?.estimated_value ?? editVehiclePrice ?? undefined,
        };

        if (vehicleId) {
          // Para vehículos ya registrados no se debe modificar el residual
          const patchData: LeasingPost = { ...valuesDetails };
          delete patchData.requested_residual_percentage;

          await patchLeasing({
            id_solicitud: String(application.id),
            vehicleId: String(vehicleId),
            data: patchData,
          }).unwrap();
        } else {
          const leasingPost = {
            leasings_list: [valuesDetails],
          };

          await postLeasing({ data: leasingPost, id_solicitud: String(application?.id) }).unwrap();
        }

        const refreshed = await getLeasingList(String(application.id)).unwrap();
        const activeVheicles = refreshed.filter((v) => v.active);
        setVehicles(activeVheicles || []);
      } catch (error) {
        const apiError = error as ApiError;

        dispatch(setModalErrorVisible({ open: true, error: apiError }));
      } finally {
        setIsLoadingForm(false);
        setOpenEditVehicle(false);
        setEditIndex(null);
        formikEdit.resetForm();
      }
    },
  });

  const openAddModal = () => {
    formikEdit.resetForm();
    setEditIndex(null);
    setVehicleType("cars");
    setBrandsOptions([]);
    setModelsOptions([]);
    setVersionsOptions([]);
    setEditVehiclePrice(0);
    setVehicleValueDetail(null);
    formikEdit.setFieldValue("residual", taxSystems?.default_residual_percentage ?? 20);
    setOpenEditVehicle(true);
  };

  const startEdit = async (index: number) => {
    setIsLoadingForm(true);
    const v = vehicles[index];
    setEditIndex(index);
    setEditVehiclePrice(v?.estimated_value ?? 0);
    const det = (v.details || {}) as {
      vehicle_type?: string;
      year?: number | string;
      make?: string;
      model?: string;
      version?: string;
    };
    const isCars = det?.vehicle_type?.includes("Autos") ?? true;
    setVehicleType(isCars ? "cars" : "trucks");

    // cantidad y residual
    formikEdit.setFieldValue("carAmount", v.quantity || 1);
    const resPerc =
      v.requested_residual_percentage ?? v.selected_residual_percentage ?? v.approved_residual_percentage ?? 20;
    formikEdit.setFieldValue("residual", resPerc);

    const yearStr = String(det?.year ?? "");
    formikEdit.setFieldValue("year", yearStr);

    if (isCars && yearStr) {
      setIsLoadingForm(true);
      try {
        const brandsRes = await triggerGetVehicleByYear({ year: yearStr }).unwrap();
        setBrandsOptions(brandsRes);
        const brandOpt = brandsRes.find((b) => b.name === (det?.make ?? ""));
        if (brandOpt) {
          formikEdit.setFieldValue("brand", brandOpt.code);
          formikEdit.setFieldValue("brand_value", brandOpt.name);

          const modelsRes = await triggerGetVehicleByYearAndBrand({ year: yearStr, make: brandOpt.code }).unwrap();
          setModelsOptions(modelsRes);
          const modelOpt = modelsRes.find((m) => m.name === (det?.model ?? ""));
          if (modelOpt) {
            formikEdit.setFieldValue("model", modelOpt.code);
            formikEdit.setFieldValue("model_value", modelOpt.name);

            const versionsRes = await triggerGetVehicleByYearBrandAndModel({
              year: yearStr,
              make: brandOpt.code,
              model: modelOpt.code,
            }).unwrap();
            setVersionsOptions(versionsRes);
            const versionOpt = versionsRes.find((vv) => vv.name === (det?.version ?? ""));
            if (versionOpt) {
              formikEdit.setFieldValue("version", versionOpt.code);
              formikEdit.setFieldValue("version_value", versionOpt.name);
              const price = await triggerGetPriceVehiclesByVersion({ version: versionOpt.code }).unwrap();
              setEditVehiclePrice((price as { sale_price?: number })?.sale_price ?? 0);
            }
          }
        }
      } catch (error) {
        const apiError = error as ApiError;

        dispatch(setModalErrorVisible({ open: true, error: apiError }));
      } finally {
        setIsLoadingForm(false);
      }
    } else {
      // trucks: setear campos texto y valor unitario desde servicio (si disponible)
      formikEdit.setFieldValue("brand", det?.make ?? "");
      formikEdit.setFieldValue("brand_value", det?.make ?? "");
      formikEdit.setFieldValue("model", det?.model ?? "");
      formikEdit.setFieldValue("model_value", det?.model ?? "");
      formikEdit.setFieldValue("version", det?.version ?? "");
      formikEdit.setFieldValue("version_value", det?.version ?? "");
      const unitPrice = v?.estimated_value ?? 0;
      formikEdit.setFieldValue("price", unitPrice || null);
      setEditVehiclePrice(unitPrice);
      setDisplayPrice(unitPrice ? new Intl.NumberFormat("es-MX").format(unitPrice) : "");
    }
    setIsLoading(false);
    setOpenEditVehicle(true);
    setIsLoadingForm(false);
  };

  // Handlers cascada dentro del modal
  const handleYearChangeEdit = async (e: SelectChangeEvent<string>) => {
    try {
      const value = e.target.value as string;
      formikEdit.setFieldValue("year", value);
      setIsLoadingForm(true);
      const res = value ? await triggerGetVehicleByYear({ year: value }).unwrap() : [];
      setBrandsOptions(res);
      setModelsOptions([]);
      setVersionsOptions([]);
      formikEdit.setFieldValue("brand", "");
      formikEdit.setFieldValue("brand_value", "");
      formikEdit.setFieldValue("model", "");
      formikEdit.setFieldValue("model_value", "");
      formikEdit.setFieldValue("version", "");
      formikEdit.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleBrandChangeEdit = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const year = formikEdit.values.year;
      const selectedBrand = brandsOptions.find((b) => b.code === value);
      formikEdit.setFieldValue("brand", value);
      formikEdit.setFieldValue("brand_value", selectedBrand?.name || "");
      const res = value ? await triggerGetVehicleByYearAndBrand({ year, make: value }).unwrap() : [];
      setModelsOptions(res);
      setVersionsOptions([]);
      formikEdit.setFieldValue("model", "");
      formikEdit.setFieldValue("model_value", "");
      formikEdit.setFieldValue("version", "");
      formikEdit.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleModelChangeEdit = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const year = formikEdit.values.year;
      const brand = formikEdit.values.brand;
      const selectedModel = modelsOptions.find((m) => m.code === value);
      formikEdit.setFieldValue("model", value);
      formikEdit.setFieldValue("model_value", selectedModel?.name || "");
      const res = await triggerGetVehicleByYearBrandAndModel({ year, make: brand, model: value }).unwrap();
      setVersionsOptions(res);
      formikEdit.setFieldValue("version", "");
      formikEdit.setFieldValue("version_value", "");
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleVersionChangeEdit = async (e: SelectChangeEvent<string>) => {
    try {
      setIsLoadingForm(true);
      const value = e.target.value as string;
      const selectedVersion = versionsOptions.find((b) => b.code === value);
      formikEdit.setFieldValue("version", value);
      formikEdit.setFieldValue("version_value", selectedVersion?.name || "");
      const response = await triggerGetPriceVehiclesByVersion({ version: value }).unwrap();
      setEditVehiclePrice((response as { sale_price?: number })?.sale_price ?? 0);
      setVehicleValueDetail(response);
      formikEdit.setFieldValue("price", response?.sale_price || null);
    } catch (error) {
      const apiError = error as ApiError;

      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleDelete = async (index: number) => {
    try {
      setIsLoadingForm(true);
      const vehicleToDelete = vehicles[index];
      if (vehicleToDelete && vehicleToDelete.id) {
        await deleteVehicleById({ id_solicitud: String(application.id), vehicleId: vehicleToDelete.id }).unwrap();
        setVehicles((prev) => prev.filter((_, i) => i !== index));
      }
    } catch (error) {
      const apiError = error as ApiError;
      Sentry.captureException(error, {
        extra: {
          component: "ofertaArrendamiento-submit",
        },
      });
      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleConfirmContinue = async () => {
    try {
      if (leasingTotals.totalValue > configConditions.amount) {
        setSubmitError(true);
        return;
      }

      setIsLoading(true);
      const { check_list, informacion_documentos_pfae } = STATUS_CATALOG;

      const advanceValue = round2(leasingTotals.totalValue * (selectedAdvance / 100));

      const data = {
        loan_application: application.id,
        loan_amount: condition?.selected_amount,
        requested_term: condition?.requested_term || 0,
        selected_amount: condition?.selected_amount || 0,
        selected_term: selectedTerm || 0,
        requested_amount: condition?.requested_amount || 0,

        selected_advance_percentage: selectedAdvance,
        selected_advance_value: advanceValue,
      };
      await putCondition({ body: data, id: String(condition?.id) }).unwrap();

      await triggerPostNextStage({
        applicationId: application.id,
        statusCode: check_list.code,
        username: `TOFU - ${accountUser.email}`,
      }).unwrap();

      dispatch(setLoanStatus(check_list.code));

      if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
        navigate(check_list.url);
      } else {
        navigate(informacion_documentos_pfae.url);
      }
    } catch (error) {
      const apiError = error as ApiError;
      Sentry.captureException(error, {
        extra: {
          component: "ofertaArrendamiento-submit",
        },
      });
      dispatch(setModalErrorVisible({ open: true, error: apiError }));
    }
  };

  const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

  const closeErrorAlert = () => {
    setSubmitError(false);
  };

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8}>
        <Box maxWidth="sm" mx="auto" mt={4} px={isMobileOrTablet ? 0 : 2}>
          <Typography textAlign={"center"} fontSize={"20px"} fontWeight={500} color={theme?.palette?.primary?.main}>
            ¡Felicidades!
            <br />
            {companyData.name} <br />
            ¡Tu arrendamiento ha sido autorizado!
          </Typography>

          <Typography
            textAlign={"center"}
            variant={"body1"}
            fontWeight={300}
            color={theme?.palette?.primary?.dark}
            mt={4}
          >
            Monto máximo autorizado
          </Typography>

          {isLoading ? (
            <>
              <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: "8px" }} />
            </>
          ) : (
            <Typography
              textAlign={"center"}
              fontSize={"20px"}
              fontWeight={600}
              color={theme?.palette?.primary?.main}
              mt={1}
            >
              {formatCurrency(configConditions.amount)}{" "}
              <Typography variant="body3" fontWeight={600}>
                {interfaceConfig.cotizador?.current_currency || "MXN"}
              </Typography>
            </Typography>
          )}

          <Typography
            textAlign={"center"}
            variant={"body1"}
            fontWeight={600}
            color={theme?.palette?.primary?.dark}
            mt={4}
            mb={1}
          >
            Vehículo(s)
          </Typography>
          {isLoading ? (
            <>
              <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: "8px" }} />
            </>
          ) : (
            <VehiculosTable
              headerBgColor={theme?.palette?.primary?.base}
              headerTextColor={theme?.palette?.primary?.dark}
              borderColor={theme?.palette?.primary?.light}
              iconEdit={theme?.palette?.primary?.dark}
              iconDelete={theme?.palette?.primary?.main}
              bodyTextColor={theme?.palette?.primary?.dark}
              onEdit={startEdit}
              onDelete={handleDelete}
              rows={(vehicles ?? []).map((v) => ({
                vehiculo: `${v.details?.make || ""} ${v.details?.model || ""} ${v.details?.version || ""}, ${
                  v.details?.year || ""
                }`,
                cantidad: v.quantity || 1,
                monto: `${formatCurrency((v.estimated_value ?? 0) * (v.quantity || 1))} ${
                  interfaceConfig.cotizador?.current_currency || "MXN"
                }`,
                residual: `${
                  v.requested_residual_percentage ??
                  v.selected_residual_percentage ??
                  v.approved_residual_percentage ??
                  0
                }%`,
              }))}
              isLoading={isLoadingForm}
            />
          )}

          <Box display={"flex"} justifyContent={"center"} mt={2}>
            <Button
              variant="default"
              sx={{ width: 160, fontSize: "12px", padding: 1 }}
              onClick={openAddModal}
              disabled={isLoadingForm || leasingTotals.totalValue > configConditions.amount}
            >
              <ControlPointIcon sx={{ mr: 1 }} /> Agregar Vehículo
            </Button>
          </Box>

          <Box
            mt={3}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: theme?.palette?.primary?.base,
              padding: "10px 12px",
              borderRadius: "8px",
              paddingLeft: { xs: "12px", sm: "26px" },
              paddingRight: { xs: "12px", sm: "106px" },
            }}
          >
            <WarningAmberIcon
              sx={{
                color: theme?.palette?.primary?.light,
                fontSize: 40,
              }}
            />

            <Typography
              sx={{
                fontSize: "14px",
                color: theme?.palette?.primary?.light,
                lineHeight: 1.4,
              }}
              textAlign={"justify"}
              pl={2}
            >
              Puedes cambiar los vehículos sin exceder el monto máximo pero este proceso requerirá de una autorización,
              misma que se gestionará mientras continuas.
            </Typography>
          </Box>

          {submitError && (
            <Box
              mt={3}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#e21e13",
                padding: "10px 12px",
                borderRadius: "8px",
                paddingLeft: { xs: "12px", sm: "26px" },
                paddingRight: { xs: "12px", sm: "106px" },
                cursor: "pointer",
              }}
              onClick={closeErrorAlert}
            >
              <WarningAmberIcon
                sx={{
                  color: "#ffffff",
                  fontSize: 40,
                }}
              />

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#ffffff",
                  lineHeight: 1.4,
                }}
                textAlign={"justify"}
                pl={2}
              >
                El valor de los vehículos no puede ser mayor al monto máximo autorizado.
              </Typography>
            </Box>
          )}

          <Typography
            textAlign={"center"}
            variant={"body1"}
            fontWeight={400}
            color={theme?.palette?.primary?.dark}
            mt={4}
          >
            Confirma el plazo en meses
          </Typography>

          <Box
            display={"flex"}
            justifyContent={"center"}
            gap={1}
            mt={2}
            flexWrap={"wrap"}
            sx={{
              "& > *": { marginX: 0.5 },
            }}
          >
            {isLoading ? (
              <Skeleton variant="rectangular" width={70} height={35} sx={{ borderRadius: "8px" }} />
            ) : (
              <>
                {(termMarket ?? []).map((term) => (
                  <ButtonTypeSelectedCustom
                    key={term}
                    title={String(term)}
                    onClick={() => setSelectedTerm(term)}
                    isSelected={selectedTerm === term}
                    isMovile={isMobileOrTablet}
                    height={"35px"}
                    heightMoviles="35px"
                    width="70px"
                    widthMoviles="70px"
                    font_size="11px"
                    font_size_movil="11px"
                    font_weight={500}
                    bgColor={theme?.palette?.primary?.base}
                    borderColor={theme?.palette?.primary?.light}
                    bgColorActive={theme?.palette?.primary?.light}
                    hoverBgColor={theme?.palette?.primary?.light}
                    hoverTextColor={theme?.palette?.primary?.dark}
                    textColor={theme?.palette?.primary?.dark}
                    textColorActive={theme?.palette?.primary?.dark}
                  />
                ))}
              </>
            )}
          </Box>
          <Typography
            textAlign={"center"}
            variant={"body1"}
            fontWeight={400}
            color={theme?.palette?.primary?.dark}
            mt={2}
          >
            Confirmar el anticipo
          </Typography>

          <Box mt={1} mb={2}>
            <StyledSlider
              aria-label="amount"
              min={configConditions.min_advance_percentage}
              max={configConditions.max_advance_percentage}
              step={configConditions.jump_advance_percentage}
              marks={advancePercentageMarket}
              defaultValue={0}
              value={selectedAdvance}
              onChange={(_event, newValue) => setSelectedAdvance(newValue as number)}
              disabled={isLoading}
            />
          </Box>

          <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
            <Box width={"45%"}>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                textAlign={"center"}
                color={theme?.palette?.primary?.dark}
              >
                Valor del anticipo
              </Typography>
              <Typography
                fontSize={"18px"}
                fontWeight={600}
                textAlign={"center"}
                mt={1}
                color={theme?.palette?.primary?.main}
              >
                {formatCurrency(leasingTotals.advanceAmount || 0)}{" "}
                <Typography variant="body3" fontWeight={500}>
                  {interfaceConfig.cotizador?.current_currency || "MXN"}
                </Typography>
              </Typography>
            </Box>

            <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
            </Box>

            <Box width={"45%"}>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                textAlign={"center"}
                color={theme?.palette?.primary?.dark}
              >
                Valor del residual
              </Typography>

              <Typography
                fontSize={"18px"}
                fontWeight={600}
                textAlign={"center"}
                color={theme?.palette?.primary?.main}
                mt={1}
              >
                {formatCurrency(leasingTotals.residualAmount || 0)}{" "}
                <Typography variant="body3" fontWeight={500}>
                  {interfaceConfig.cotizador?.current_currency || "MXN"}
                </Typography>
              </Typography>
            </Box>
          </Box>

          {/* Modal de edición de vehículo (formulario completo con catálogos) */}
          <CustomDialog
            open={openEditVehicle}
            onClose={() => setOpenEditVehicle(false)}
            colorClose="#404657"
            closeBgColor="#F0F1F6"
            closeButtonSize={28}
            closeIconSize={20}
            itemTitle={
              <Typography color={theme?.palette?.primary?.dark} fontWeight={500} fontSize={"14px"} textAlign={"center"}>
                {editIndex !== null ? "Editar vehículo" : "Agregar vehículo"}
              </Typography>
            }
            itemContent={
              <Box width={isMobileOrTablet ? "100%" : "400px"}>
                <Typography
                  textAlign={"center"}
                  variant={"body1"}
                  fontWeight={400}
                  color={theme?.palette?.primary?.dark}
                  mt={4}
                >
                  Selecciona el tipo de vehículo
                </Typography>

                <Grid container spacing={isMobileOrTablet ? 2 : 2} mt={1} mr={isMobileOrTablet ? 1 : 0}>
                  <Grid item xs={6} md={6} display="flex" justifyContent={"flex-end"}>
                    {!isLoadingForm ? (
                      <ButtonTypeSelectedCustom
                        title="Autos o SUVs"
                        onClick={() => setVehicleType("cars")}
                        isSelected={vehicleType === "cars"}
                        isMovile={isMobileOrTablet}
                        height={"60px"}
                        heightMoviles="60px"
                        width={"180px"}
                        widthMoviles="160px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={"14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                        font_weight={600}
                        bgColor={theme?.palette?.primary?.base}
                        borderColor={theme?.palette?.primary?.light}
                        bgColorActive={theme?.palette?.primary?.light}
                        hoverBgColor={theme?.palette?.primary?.light}
                        hoverTextColor={theme?.palette?.primary?.dark}
                        textColor={theme?.palette?.primary?.dark}
                        textColorActive={theme?.palette?.primary?.dark}
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                  <Grid item xs={6} md={6} display="flex" justifyContent={"flex-start"}>
                    {!isLoadingForm ? (
                      <ButtonTypeSelectedCustom
                        title="Vans o camiones"
                        onClick={() => setVehicleType("trucks")}
                        isSelected={vehicleType === "trucks"}
                        isMovile={isMobileOrTablet}
                        height={"60px"}
                        heightMoviles="60px"
                        width={"190px"}
                        widthMoviles="160px"
                        icon={icon_check}
                        width_icon="22px"
                        height_icon="22px"
                        font_size={"14px"}
                        top_icon="-12px"
                        font_size_movil="11px"
                        font_weight={600}
                        bgColor={theme?.palette?.primary?.base}
                        borderColor={theme?.palette?.primary?.light}
                        bgColorActive={theme?.palette?.primary?.light}
                        hoverBgColor={theme?.palette?.primary?.light}
                        hoverTextColor={theme?.palette?.primary?.dark}
                        textColor={theme?.palette?.primary?.dark}
                        textColorActive={theme?.palette?.primary?.dark}
                      />
                    ) : (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={isMobileOrTablet ? 150 : 190}
                        height={isMobileOrTablet ? 60 : 70}
                      />
                    )}
                  </Grid>
                </Grid>

                <Box>
                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={4}
                  >
                    Selecciona el vehículo
                  </Typography>
                </Box>

                <form onSubmit={formikEdit.handleSubmit} noValidate>
                  {vehicleType === "trucks" ? (
                    <>
                      <TextField
                        fullWidth
                        label="Año"
                        name="year"
                        value={formikEdit.values.year}
                        onChange={(e) => {
                          const value = e.target.value as string;
                          if (/^\d{0,4}$/.test(value)) {
                            formikEdit.handleChange(e);
                          }
                        }}
                        onBlur={formikEdit.handleBlur}
                        id="year"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formikEdit.touched.year && Boolean(formikEdit.errors.year)}
                        helperText={formikEdit.touched.year && (formikEdit.errors.year as string)}
                        inputProps={{ maxLength: 4 }}
                      />
                      <TextField
                        fullWidth
                        label="Marca"
                        name="brand"
                        value={formikEdit.values.brand}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id="brand"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formikEdit.touched.brand && Boolean(formikEdit.errors.brand)}
                        helperText={formikEdit.touched.brand && (formikEdit.errors.brand as string)}
                      />
                      <TextField
                        fullWidth
                        label="Modelo"
                        name="model"
                        value={formikEdit.values.model}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id="model"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formikEdit.touched.model && Boolean(formikEdit.errors.model)}
                        helperText={formikEdit.touched.model && (formikEdit.errors.model as string)}
                      />
                      <TextField
                        fullWidth
                        label="Versión"
                        name="version"
                        value={formikEdit.values.version}
                        onChange={formikEdit.handleChange}
                        onBlur={formikEdit.handleBlur}
                        id="version"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formikEdit.touched.version && Boolean(formikEdit.errors.version)}
                        helperText={formikEdit.touched.version && (formikEdit.errors.version as string)}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{ mt: 3 }}
                          error={formikEdit.touched.year && Boolean(formikEdit.errors.year)}
                        >
                          <InputLabel id="year">Año</InputLabel>
                          <Select
                            labelId="year"
                            id="year"
                            name="year"
                            fullWidth
                            required
                            label="Año"
                            value={formikEdit.values.year}
                            onBlur={formikEdit.handleBlur}
                            onChange={handleYearChangeEdit}
                            disabled={isLoadingForm}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {listYears?.map((year) => (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                          {formikEdit.touched.year && formikEdit.errors.year && (
                            <FormHelperText>{formikEdit.errors.year as string}</FormHelperText>
                          )}
                        </FormControl>
                      )}

                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{ mt: 3 }}
                          error={formikEdit.touched.brand && Boolean(formikEdit.errors.brand)}
                        >
                          <InputLabel id="brand">Marca</InputLabel>
                          <Select
                            labelId="brand"
                            id="brand"
                            name="brand"
                            fullWidth
                            required
                            label="Marca"
                            value={formikEdit.values.brand}
                            onBlur={formikEdit.handleBlur}
                            onChange={handleBrandChangeEdit}
                            disabled={isLoadingForm || !formikEdit.values.year}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {brandsOptions?.map((brand) => (
                              <MenuItem key={brand.code} value={brand.code}>
                                {brand.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formikEdit.touched.brand && formikEdit.errors.brand && (
                            <FormHelperText>{formikEdit.errors.brand as string}</FormHelperText>
                          )}
                        </FormControl>
                      )}

                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{ mt: 3 }}
                          error={formikEdit.touched.model && Boolean(formikEdit.errors.model)}
                        >
                          <InputLabel id="model">Modelo</InputLabel>
                          <Select
                            labelId="model"
                            id="model"
                            name="model"
                            fullWidth
                            required
                            label="Modelo"
                            value={formikEdit.values.model}
                            onBlur={formikEdit.handleBlur}
                            onChange={handleModelChangeEdit}
                            disabled={isLoadingForm || !formikEdit.values.brand}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {modelsOptions?.map((model) => (
                              <MenuItem key={model.code} value={model.code}>
                                {model.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formikEdit.touched.model && formikEdit.errors.model && (
                            <FormHelperText>{formikEdit.errors.model as string}</FormHelperText>
                          )}
                        </FormControl>
                      )}

                      {isLoadingForm ? (
                        <Box sx={{ mt: 2 }}>
                          <Skeleton variant="rectangular" animation="wave" width={"100%"} height={56} />
                        </Box>
                      ) : (
                        <FormControl
                          fullWidth
                          required
                          sx={{ mt: 3 }}
                          error={formikEdit.touched.version && Boolean(formikEdit.errors.version)}
                        >
                          <InputLabel id="version">Versión</InputLabel>
                          <Select
                            labelId="version"
                            id="version"
                            name="version"
                            fullWidth
                            required
                            label="Versión"
                            value={formikEdit.values.version}
                            onBlur={formikEdit.handleBlur}
                            onChange={handleVersionChangeEdit}
                            disabled={isLoadingForm || !formikEdit.values.model}
                          >
                            <MenuItem value={""}>Selecciona</MenuItem>
                            {versionsOptions?.map((vopt) => (
                              <MenuItem key={vopt.code} value={vopt.code}>
                                {vopt.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {formikEdit.touched.version && formikEdit.errors.version && (
                            <FormHelperText>{formikEdit.errors.version as string}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </>
                  )}

                  {vehicleType === "trucks" && (
                    <>
                      <TextField
                        fullWidth
                        label="Valor del vehículo"
                        name="price"
                        value={displayPrice}
                        onChange={(e) => {
                          const raw = (e.target.value || "").replace(/[^\d]/g, "");
                          if (raw.length <= 10) {
                            const num = raw ? Number(raw) : 0;
                            setDisplayPrice(num ? new Intl.NumberFormat("es-MX").format(num) : "");
                            formikEdit.setFieldValue("price", num || null);
                            setEditVehiclePrice(num);
                          }
                        }}
                        onBlur={formikEdit.handleBlur}
                        id="price"
                        margin="normal"
                        required
                        autoComplete="off"
                        error={formikEdit.touched.price && Boolean(formikEdit.errors.price)}
                        helperText={formikEdit.touched.price && formikEdit.errors.price}
                        disabled={formikEdit.isSubmitting}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AttachMoneyIcon fontSize="small" />
                            </InputAdornment>
                          ),
                          inputMode: "numeric",
                        }}
                        inputProps={{ maxLength: 11 }}
                      />
                    </>
                  )}

                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={4}
                  >
                    Selecciona la cantidad
                  </Typography>
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    gap={0.5}
                    mt={2}
                    flexWrap={"wrap"}
                    sx={{ "& > *": { marginX: isMobileOrTablet ? 0.3 : 0.5 } }}
                  >
                    {isLoadingForm ? (
                      <Box sx={{ mt: 2 }}>
                        <Skeleton variant="rectangular" animation="wave" width={20} height={35} />
                      </Box>
                    ) : (
                      <>
                        {amount.map((num) => (
                          <ButtonTypeSelectedCustom
                            key={num}
                            title={String(num)}
                            onClick={() => formikEdit.setFieldValue("carAmount", num)}
                            isSelected={Number(formikEdit.values.carAmount) === num}
                            isMovile={isMobileOrTablet}
                            height={"35px"}
                            heightMoviles="35px"
                            width="22px"
                            widthMoviles="22px"
                            font_size="11px"
                            font_size_movil="11px"
                            font_weight={500}
                            bgColor={theme?.palette?.primary?.base}
                            borderColor={theme?.palette?.primary?.light}
                            bgColorActive={theme?.palette?.primary?.light}
                            hoverBgColor={theme?.palette?.primary?.light}
                            hoverTextColor={theme?.palette?.primary?.dark}
                            textColor={theme?.palette?.primary?.dark}
                            textColorActive={theme?.palette?.primary?.dark}
                          />
                        ))}
                      </>
                    )}
                  </Box>

                  <Typography
                    textAlign={"center"}
                    variant={"body1"}
                    fontWeight={400}
                    color={theme?.palette?.primary?.dark}
                    mt={2}
                  >
                    Confirma el residual
                  </Typography>
                  <Box mt={1} mb={2}>
                    <StyledSlider
                      aria-label="residual"
                      min={10}
                      max={configConditions.max_residual_percentage}
                      step={configConditions.jump_residual_percentage}
                      marks={residualPercentageMarket}
                      value={Number(formikEdit.values.residual)}
                      onChange={(_event, newValue) => formikEdit.setFieldValue("residual", newValue as number)}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant={isMobileOrTablet ? "body2" : "body1"}
                      fontWeight={400}
                      textAlign={"center"}
                      color={theme?.palette?.primary?.dark}
                    >
                      Valor del residual
                    </Typography>
                    <Typography
                      fontSize={"18px"}
                      fontWeight={600}
                      textAlign={"center"}
                      mt={1}
                      color={theme?.palette?.primary?.main}
                    >
                      {formatCurrency(
                        editVehiclePrice *
                          Number(formikEdit.values.carAmount || 1) *
                          (Number(formikEdit.values.residual) / 100),
                      )}{" "}
                      <Typography variant="body3" fontWeight={500}>
                        {interfaceConfig.cotizador?.current_currency || "MXN"}
                      </Typography>
                    </Typography>
                  </Box>

                  <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
                    <Box width={"45%"}>
                      <Typography
                        variant={isMobileOrTablet ? "body2" : "body1"}
                        fontWeight={400}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.dark}
                      >
                        Valor del vehículo
                      </Typography>
                      <Typography
                        fontSize={"18px"}
                        fontWeight={600}
                        textAlign={"center"}
                        mt={1}
                        color={theme?.palette?.primary?.main}
                      >
                        {formatCurrency(editVehiclePrice)}{" "}
                        <Typography variant="body3" fontWeight={500}>
                          {interfaceConfig.cotizador?.current_currency || "MXN"}
                        </Typography>
                      </Typography>
                    </Box>

                    <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                      <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
                    </Box>

                    <Box width={"45%"}>
                      <Typography
                        variant={isMobileOrTablet ? "body2" : "body1"}
                        fontWeight={400}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.dark}
                      >
                        Monto a financiar
                      </Typography>

                      <Typography
                        fontSize={"18px"}
                        fontWeight={600}
                        textAlign={"center"}
                        color={theme?.palette?.primary?.main}
                        mt={1}
                      >
                        {formatCurrency(
                          editVehiclePrice * Number(formikEdit.values.carAmount || 1) -
                            editVehiclePrice * Number(formikEdit.values.carAmount || 1) * (selectedAdvance / 100),
                        )}{" "}
                        <Typography variant="body3" fontWeight={500}>
                          {interfaceConfig.cotizador?.current_currency || "MXN"}
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <Button variant="default" sx={{ width: 160, fontSize: "12px", padding: 1 }} type="submit">
                      Guardar cambios
                    </Button>
                  </Box>
                </form>
              </Box>
            }
          />

          <Box display={"flex"} flexDirection={"row"} mt={4} mb={4}>
            <Box width={"45%"}>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                textAlign={"center"}
                color={theme?.palette?.primary?.dark}
              >
                Valor del vehículo
              </Typography>
              <Typography
                fontSize={"18px"}
                fontWeight={600}
                textAlign={"center"}
                mt={1}
                color={theme?.palette?.primary?.main}
              >
                {formatCurrency(leasingTotals.totalValue || 0)}{" "}
                <Typography variant="body3" fontWeight={500}>
                  {interfaceConfig.cotizador?.current_currency || "MXN"}
                </Typography>
              </Typography>
            </Box>

            <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
              <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
            </Box>

            <Box width={"45%"}>
              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                fontWeight={400}
                textAlign={"center"}
                color={theme?.palette?.primary?.dark}
              >
                Monto a financiar
              </Typography>

              <Typography
                fontSize={"18px"}
                fontWeight={600}
                textAlign={"center"}
                color={theme?.palette?.primary?.main}
                mt={1}
              >
                {formatCurrency(leasingTotals.amountToFinance || 0)}{" "}
                <Typography variant="body3" fontWeight={500}>
                  {interfaceConfig.cotizador?.current_currency || "MXN"}
                </Typography>
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography fontSize={"17px"} fontWeight={700} textAlign={"center"} color={theme?.palette?.primary?.main}>
              Renta mensual estimada
            </Typography>

            <Typography
              fontSize={"22px"}
              fontWeight={700}
              textAlign={"center"}
              color={theme?.palette?.primary?.dark}
              mt={1}
            >
              {formatCurrency(leasingTotals.monthlyRent || 0)}{" "}
              <Typography variant="body3" fontWeight={700}>
                {interfaceConfig.cotizador?.current_currency || "MXN"}
              </Typography>
            </Typography>

            <Box display={"flex"} justifyContent={"center"} mt={2} mb={4}>
              <Button
                variant="default"
                disabled={isLoading || leasingTotals.totalValue === 0 || selectedTerm === null}
                onClick={handleConfirmContinue}
              >
                Continuar
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default OfertaArrendamiento;
